import classNames from 'classnames';
import { observer } from 'mobx-react';

import { CmsType } from '../../dto/cms.types';
import { useStores } from '../../stores/useStores';

export const CMSLinks = observer(() => {
  const { cmsStore } = useStores();

  const { sideMenuLinks } = cmsStore;

  return (
    <>
      {sideMenuLinks.map((cmsPage) => (
        <li key={cmsPage.cmsPageId}>
          {/* TODO to remove the backward compatibility. */}
          <a
            className={classNames('side-menu__action', {
              'support-button': (cmsPage.title?.EN || cmsPage.title?.value || '').toLowerCase().includes('contact us'),
            })}
            href={Number(cmsPage.cmsType) == CmsType.EXTERNAL ? cmsPage.targetUrl : `/pages/${cmsPage.slug}`}
            rel="noreferrer"
            target="_blank"
          >
            {cmsPage.title?.EN || cmsPage.title?.value}
          </a>
        </li>
      ))}
    </>
  );
});
